export default function activeAgendaDirective() {
  return {
    template: require('./active-agenda.html'),
    scope: {
      agenda: '=',
    },
    controller: 'ActiveAgendaController',
    controllerAs: 'activeAgendaVM',
    bindToController: true,
    replace: true
  };
}
